﻿
let notifications = document.querySelector('#notifications');
let outNotificationClass;

if (notifications) {
    outNotificationClass = notifications.dataset.removeNotification;
    let buttons = notifications.querySelectorAll('button');

    buttons.forEach((element, index, parent) => {
        element.addEventListener('click', closeNotification);
        setTimeout(function () {
            element.dispatchEvent(new Event('click'));
        }, 10000);
    });
}

export function closeNotification(e) {

    e.preventDefault();
    e.stopPropagation();

    let parent = this.parentElement;
    if (outNotificationClass) {
        parent.classList.add(outNotificationClass);
        parent.addEventListener('animationend', function () {
            this.remove();
            checkAllNotifications();
        });
    } else {
        parent.remove();
        checkAllNotifications();        
    }
}

function checkAllNotifications() {
    if (notifications.querySelectorAll('[id^="notification"]').length == 0) {
        notifications.remove();
    }
}